import React from 'react'
import { Outlet } from 'react-router-dom'

export default function OnboardingLayout(props) {
    const imageUrl = "./assets/images/";
    return (
        <div className="onboarding-layout">
            <div className='bg-[#252930] h-screen flex'>
                <div className="w-full max-w-lg m-auto">
                    <div className='bg-white rounded p-8 xl:px-16'>
                        <div className="text-center mb-12">
                            <img src={imageUrl + "logo.svg"} alt="" className='m-auto w-40' />
                        </div>
                        <Outlet />
                    </div>
                </div>
            </div>
        </div>
    )
}
